import HubSpot from '@clearkit/icons/glyphs/Hubspot';
import Marketo from '@clearkit/icons/glyphs/Marketo';
import Salesforce from '@clearkit/icons/glyphs/Salesforce';
import TrendUp from '@clearkit/icons/glyphs/TrendUp';
import { CKBox, CKButton } from 'clearkit';
import capitalize from 'lodash/capitalize';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import {
  integrationSubObjectTypes,
  integrationTypeHubSpot,
  integrationTypeMarketo,
  integrationTypeSalesforce,
} from '~/lib/dataEnrichment';

import IntegrationStatus from './IntegrationStatus';
import SubObjectIntegrationStatus from './SubObjectIntegrationStatus';

const successColor = 'green-600';
const dangerColor = 'red';

function ActiveIntegrationCard({ accountConnector }) {
  const [subIntegrationState, setSubIntegrationState] = useState({
    loaded: false,
    data: [],
  });
  const integrationType = accountConnector.service;

  const onSubIntegrationsLoaded = (subIntegrationFieldMappings) => {
    const newSubIntegrationsData = [
      ...subIntegrationState.data,
      subIntegrationFieldMappings,
    ];
    setSubIntegrationState({
      loaded:
        newSubIntegrationsData.length ===
        integrationSubObjectTypes[accountConnector.service].length,
      data: newSubIntegrationsData,
    });
  };

  return (
    <CKBox className="mb-4">
      <div className="flex flex-row items-center p-4 border-b-2 border-gray-200 grow">
        <IntegrationIcon integrationType={integrationType} />
        <div className="flex flex-col ml-2 min-h-12 grow flex-start">
          <div className="text-base font-semibold">
            {capitalize(integrationType)}
          </div>
          <div className="flex flex-row">
            <IntegrationStatus
              accountConnector={accountConnector}
              subIntegrationsData={subIntegrationState.data}
              subIntegrationsLoaded={subIntegrationState.loaded}
            />
          </div>
        </div>
        <RecordsEnriched />
        <ErrorRate />
        <div className="flex-end">
          <ConfigLink integrationType={integrationType} />
        </div>
      </div>
      <div className="flex flex-row items-center p-4 border-b-2 border-gray-200 grow">
        <div className="flex flex-col grow">
          <div className="flex flex-row">
            {integrationSubObjectTypes[integrationType].map((subObjectType) => (
              <SubObjectIntegrationStatus
                onSubIntegrationsLoaded={onSubIntegrationsLoaded}
                key={`${integrationType}-${subObjectType}`}
                accountConnectorId={accountConnector.id}
                subObjectType={subObjectType}
              />
            ))}
          </div>
        </div>
        <div className="flex flex-col flex-end">
          <CKButton
            as={Link}
            to={`/enrichment/${integrationType}/logs`}
            variant="tertiary"
            variantColor="blue">
            View Logs
          </CKButton>
        </div>
      </div>
    </CKBox>
  );
}

function ConfigLink({ integrationType }) {
  const url = `/enrichment/${integrationType}`;
  return (
    <div className="flex flex-col p-1 grow">
      <div className="p-2 border-l-2 border-gray-200">
        <CKButton as={Link} to={url} className="ml-2">
          Configure
        </CKButton>
      </div>
    </div>
  );
}
function RecordsEnriched() {
  return (
    <div className="flex flex-col p-1 grow">
      <div className="p-2 border-l-2 border-gray-200">
        <div className="flex flex-row">
          <div className="font-semibold">7,275</div>
          <div className={`ml-1 text-${successColor}`}>
            <div className="flex flex-row">
              <TrendUp />
              1,129
            </div>
          </div>
        </div>
        <div className="text-xs">Records enriched</div>
      </div>
    </div>
  );
}

function ErrorRate() {
  return (
    <div className="flex flex-col p-1 grow">
      <div className="p-2">
        <div className="flex flex-row">
          <div className="font-semibold">0.7%</div>
          <div className={`ml-1 text-${dangerColor}`}>
            <div className="flex flex-row">
              <TrendUp />
              0.2%
            </div>
          </div>
        </div>
        <div className="text-xs">Error rate</div>
      </div>
    </div>
  );
}

function IntegrationIcon({ integrationType }) {
  return (
    <CKBox
      className={`flex items-center justify-center w-10 h-12 p-2 bg-${integrationType}`}>
      <IntegrationGlyph integrationType={integrationType} />
    </CKBox>
  );
}
function IntegrationGlyph({ integrationType }) {
  const glyphProps = {
    height: '14',
    width: '14',
    className: 'text-white fill-current',
  };

  switch (integrationType) {
    case integrationTypeSalesforce:
      return <Salesforce {...glyphProps} />;

    case integrationTypeMarketo:
      return <Marketo {...glyphProps} />;
    case integrationTypeHubSpot:
      return <HubSpot {...glyphProps} />;
    default:
      return;
  }
}

export default ActiveIntegrationCard;
